module.exports = __webpack_public_path__ + "img/senior-logo-13.b0e33f77.png";